export enum ReferralRequestHeaderTitle {
  MEMBER_DETAILS = "MEMBER DETAILS",
  REFERRAL_DETAILS = "REFERRAL DETAILS",
  ICD_10 = "ICD 10",
  SERVICE_REQUESTS = "SERVICE REQUESTS",
  DOCUMENT_UPLOAD = "DOCUMENT UPLOAD",
  REVIEW = "REVIEW",
}

export const ReferralRequestHeaderLabel = [
  { label: ReferralRequestHeaderTitle.MEMBER_DETAILS, fontWeight: 500 },
  { label: ReferralRequestHeaderTitle.REFERRAL_DETAILS, fontWeight: 500 },
  { label: ReferralRequestHeaderTitle.ICD_10, fontWeight: 500 },
  { label: ReferralRequestHeaderTitle.SERVICE_REQUESTS, fontWeight: 500 },
  { label: ReferralRequestHeaderTitle.DOCUMENT_UPLOAD, fontWeight: 500 },
  { label: ReferralRequestHeaderTitle.REVIEW, fontWeight: 500 },
];

export const BackClickAlertMessage =
  "Are you sure you want to exit without saving current page?";
export const SaveDetailsAlertMessage = "Are you sure you want to save details?";

export const confirmationMessage = {
  title: "Authorization Request has been successfully sent",
  subTitle: "Request No:",
}
